import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=f8938d0c&scoped=true&lang=pug&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.styl?vue&type=style&index=0&id=f8938d0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8938d0c",
  null
  
)

export default component.exports